import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { Items } from '../model/items';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { Order, ReceiptDetails, schoolDetails } from '../model/order';
import { mergeMap, map, finalize, flatMap } from 'rxjs/operators';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFireDatabase } from 'angularfire2/database';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
declare function loadTable(): any;
import { AngularFireFunctions } from '@angular/fire/functions';
import { States } from '../model/states';

@Component({
  selector: 'app-confirm-order',
  templateUrl: './confirm-order.component.html',
  styleUrls: ['./confirm-order.component.css']
})
export class ConfirmOrderComponent implements OnInit {

  @Input() public confirmOrderList: Items[] = [];

  @ViewChild('successModal') private successModal: ElementRef;
  @ViewChild('errorModal') private errorModal: ElementRef;

  constructor(private route: ActivatedRoute, private fireStorage: AngularFireStorage, private db: AngularFireDatabase,
    private router: Router, private modalService: NgbModal, private formBuilder: FormBuilder, private firebaseFn: AngularFireFunctions) { }

  subTotalvalue: number;
  fileTypeError: Boolean = false;
  uploadContentFile: File;
  uploadContentFileSize: number;
  receiptUrl: string;
  loading: Boolean = false;
  isIncludesSchoolMask: Boolean = false;
  certFileTypeError: Boolean = false;
  uploadCertFile: File;
  uploadCertFileSize: number;
  schoolCertUrl: string;
  schoolName: string;
  orderKey: string;
  deliveryForm: FormGroup;
  orderObj: Order;
  closeResult: string;
  statesList: States[];
  deliveryCharge: number = 0.00;
  cartValue: number;

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const myArray = this.route.snapshot.queryParamMap.get('myArray');
      this.cartValue = parseFloat(this.route.snapshot.queryParamMap.get('totalValue'));
      this.subTotalvalue = this.cartValue + this.deliveryCharge;
      this.confirmOrderList = JSON.parse(myArray);
      loadTable();
      this.db.list('/states').snapshotChanges().subscribe(
        response => {
          this.statesList = response.map(c => (
            {
              key: c.payload.key, ...(c.payload.val() as any)
            }
          ));
          this.deliveryForm = this.createForm();
          this.confirmOrderList.forEach(order => {
            if (order.itemName && order.itemName.toLowerCase().indexOf('school') >= 0) {
              this.isIncludesSchoolMask = true;
            }
          });
        }, error => {
          this.loading == false;
        }
      )
    });
  }

  handleReceiptFile(event) {
    var files = event.target.files;
    if (!isNullOrUndefined(files[0])) {
      var mimeType = files[0].type;
      this.fileTypeError = false;
      this.uploadContentFile = null;
      if (mimeType != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && mimeType != 'application/pdf'
        && mimeType != 'text/plain' && mimeType != 'application/msword' && mimeType.match(/image\/*/) < 0) {
        this.fileTypeError = true;
        return;
      }
      this.uploadContentFile = files[0];
      this.uploadContentFileSize = Math.floor(this.uploadContentFile.size / 1000);
    } else {
      this.uploadContentFile = null;
    }
  }

  handleSchoolCertFile(event) {
    var files = event.target.files;
    if (!isNullOrUndefined(files[0])) {
      var mimeType = files[0].type;
      this.certFileTypeError = false;
      this.uploadCertFile = null;
      if (mimeType != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && mimeType != 'application/pdf'
        && mimeType != 'text/plain' && mimeType != 'application/msword' && mimeType.match(/image\/*/) < 0) {
        this.fileTypeError = true;
        return;
      }
      this.uploadCertFile = files[0];
      this.uploadCertFileSize = Math.floor(this.uploadCertFile.size / 1000);
    } else {
      this.uploadCertFile = null;
    }
  }

  uploadProgress: any;
  uploadCertProgress: any;
  submitOrder() {

    if (this.confirmOrderList.length > 0 && this.uploadContentFile && this.deliveryForm.valid) {
      this.loading = true;

      /*Order Object */
      let order = new Order();
      order.items = this.confirmOrderList;
      order.status = "SUBMITTED";
      order.createdDate = new Date();
      order.updatedDate = new Date();
      order.name = this.deliveryForm.get('name').value;
      order.address = this.deliveryForm.get('address').value;
      order.state = this.deliveryForm.get('state').value;
      order.pincode = this.deliveryForm.get('pincode').value;
      order.phone = this.deliveryForm.get('phone').value;
      order.email = this.deliveryForm.get('email').value;
      /*Order Object */

      var filePath = '/receipts/' + `${this.uploadContentFile.name.split('.').slice(0, -1).join('.')}_${new Date().getTime()}`;
      const fileRef = this.fireStorage.ref(filePath);
      let task = fileRef.put(this.uploadContentFile);
      this.uploadProgress = task.snapshotChanges().pipe(map((s => (s.bytesTransferred / s.totalBytes) * 100)));
      task.snapshotChanges().pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe((url) => {
            this.receiptUrl = url;
            order.receiptDetails = new ReceiptDetails();
            order.receiptDetails.receiptUrl = this.receiptUrl;
            order.receiptDetails.fileName = this.uploadContentFile.name;
            order.receiptDetails.fileType = this.uploadContentFile.type;
            if (this.isIncludesSchoolMask) {
              var certFilePath = '/school-certs/' + `${this.uploadCertFile.name.split('.').slice(0, -1).join('.')}_${new Date().getTime()}`;
              const certFileRef = this.fireStorage.ref(certFilePath);
              let certTask = certFileRef.put(this.uploadCertFile);
              this.uploadCertProgress = certTask.snapshotChanges().pipe(map((s => (s.bytesTransferred / s.totalBytes) * 100)));

              certTask.snapshotChanges().pipe(
                finalize(() => {
                  certFileRef.getDownloadURL().subscribe((vertUrl) => {
                    this.schoolCertUrl = vertUrl;
                    order.schoolDetails = new schoolDetails();
                    order.schoolDetails.schoolCertUrl = this.schoolCertUrl;
                    order.schoolDetails.schoolName = this.schoolName;
                    order.schoolDetails.certFileName = this.uploadCertFile.name;
                    order.schoolDetails.certFileType = this.uploadCertFile.type;
                    this.db.list('/order/').push(order).then(response => {
                      this.orderKey = response.key;
                      this.sendMail();
                    }, error => {
                      this.loading = false;
                      console.log(error);
                      this.openModal(this.errorModal);
                      setTimeout(() => {
                        this.modalService.dismissAll();
                      }, 2000);
                    })
                  }, error => {
                    this.loading = false;
                    console.log(error);
                    this.openModal(this.errorModal);
                    setTimeout(() => {
                      this.modalService.dismissAll();
                    }, 2000);
                  });
                })
              ).subscribe();
            } else {
              order.schoolDetails = null;
              this.db.list('/order/').push(order).then(response => {
                this.orderKey = response.key;
                this.sendMail();
              }, error => {
                this.loading = false;
                console.log(error);
                this.openModal(this.errorModal);
                setTimeout(() => {
                  this.modalService.dismissAll();
                }, 2000);
              })
            }
          }, error => {
            this.loading = false;
            console.log(error);
            this.openModal(this.errorModal);
            setTimeout(() => {
              this.modalService.dismissAll();
            }, 2000);
          })
        })
      ).subscribe();
    }
  }




  createForm() {
    return this.formBuilder.group({
      name: ['', Validators.required],
      address: ['', Validators.required],
      state: ['', Validators.required],
      pincode: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
    })
  }

  sendMail() {
    this.db.object('/order/' + this.orderKey)
      .snapshotChanges().subscribe(
        response => {
          this.orderObj = new Order(response.payload.val());
          this.orderObj.key = this.orderKey;
          var functions = this.firebaseFn.functions;
          let toEmail = "bs@lsspi.com;chyehuat@scgmbhd.com;davidcheng@scgmbhd.com;scgm.order@lsspi.com";
          const callable = functions.httpsCallable('sendMail');
          var reqBody = {
            "emails": toEmail,
            "orderkey": this.orderKey,
            "receipt": this.orderObj.receiptDetails.receiptUrl,
            "fileName": this.orderObj.receiptDetails.fileName,
            "fileType": this.orderObj.receiptDetails.fileType,
            "order": JSON.stringify(this.orderObj)
          };
          callable(reqBody).then(response => {
            this.loading = false;
            this.openModal(this.successModal);
            setTimeout(() => {
              this.modalService.dismissAll();
            }, 2000);
            this.router.navigate(['']);
          }).catch(error => {
            this.loading = false;
            console.log(error);
            this.openModal(this.successModal);
            setTimeout(() => {
              this.modalService.dismissAll();
            }, 2000);
            this.router.navigate(['']);
          });
        }
      );
  }


  cancelOrder() {
    this.deliveryForm.reset();
    this.router.navigate(['']);
  }


  setDeliveryCharge(event) {
    if (event.target.value) {
      this.statesList.forEach(stateObj => {
        if (stateObj.state == event.target.value) {
          this.deliveryCharge = parseFloat(stateObj.deliverCharge);
          this.subTotalvalue = this.deliveryCharge + this.cartValue;
        }
      });
    }
  }

  openModal(content) {
    this.modalService.dismissAll();
    this.modalService.open(content, { backdrop: 'static', ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      this.loading = false;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      this.loading = false;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
